module.exports = __webpack_public_path__ + "static/media/buy-demi-button.917eeab6.png";